export class BaseStore {
    subscriberId = 0;
    subscribers = new Map();
    sync() {
        this.state = this.computeLatestState();
        for (const callback of this.subscribers.values()) {
            callback();
        }
    }
    subscribe = (callback) => {
        const index = this.subscriberId++;
        this.subscribers.set(index, callback);
        return () => {
            this.subscribers.delete(index);
        };
    };
    getState = () => this.state;
}
//# sourceMappingURL=baseStore.js.map